module.exports = __webpack_public_path__ + "static/media/covidnstuff.61ba1c80.jpg";